export const MyCampaignsImg = {
    calendarIcon: require("../../static/img/calendarIcon.png"),

};
